module.exports = __webpack_public_path__ + "static/media/Logo-07.aed76859.jpg";